<template>
    <form class="login-form" @submit.prevent="submitForm">
        <errors-list :errors="errors"/>
        <div class="form-row hidden" v-if="userDefaultId">
          <input type="hidden" name="user_id" :value="userDefaultId" v-if="userDefaultId">
        </div>
        <div class="form-row" v-else>
            <default-field-box type="email" name="email" :placeholder="$t('forms.email')" :required="true"/>
        </div>
        <div class="form-row">
            <default-field-box type="password" name="password" :placeholder="$t('forms.password')" :required="true"/>
        </div>
        <div class="form-actions">
            <button type="submit" class="button style-4" :class="loading ? 'loading' : ''">
                <span class="inner">{{ $t('auth.log_in') }}</span>
            </button>
        </div>
    </form>
</template>

<script>
    import DefaultFieldBox from "../form-fields/DefaultFieldBox";
    import ErrorsList from "../containers/ErrorsList";
    import { trackEvent } from '@/analytics';

    export default {
        name: "LoginForm",
        components: {
            DefaultFieldBox,
            ErrorsList,
        },
        data() {
            return {
                errors: false,
                loading: false,
            }
        },
        computed:{
            userDefaultId() {
              return this.$store.state.auth.userDefaultId;
            }
        },
        methods: {
            submitForm(e){
                let form = e.target;
                let formData = new FormData(form);

                let afterLoginAction = this.$store.state.auth.afterLoginAction;
                if (afterLoginAction) {
                    formData.append('after_login_action', afterLoginAction);
                }

                this.loading = true;
                trackEvent('form_submit', { form_name: 'login', module: 'auth' });
                this.$store.dispatch('login', formData).then(() => {
                    this._submitSuccess = true;
                    trackEvent('form_submit_success', { form_name: 'login', module: 'auth' });
                }).catch((error) => {
                    trackEvent('form_submit_error', {
                        form_name: 'login',
                        module: 'auth',
                        error_message: error && error.response && error.response.data ? error.response.data.message : (error && error.message),
                        error_status: error && error.response ? String(error.response.status) : null,
                    });
                    this.loading = false;
                });
            }
        },
        mounted() {
            this._submitSuccess = false;
            trackEvent('form_open', { form_name: 'login', module: 'auth' });
            this.$root.$on('socials-login-loading-status', (data) => {
                this.loading = data;
            });
        },
        beforeDestroy() {
            if (!this._submitSuccess) {
                trackEvent('form_close', { form_name: 'login', module: 'auth' });
            }
        },
        destroyed() {
            this.$root.$off('socials-login-loading-status');
        }
    }
</script>

<style scoped lang="scss">
  .form-row.hidden {
    display: none;
  }
</style>